import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { btnGold, inputCls } from "./ui";

function ReviewForm({ order, item, onDone }) {
  const [rating, setRating] = useState(5);
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    const fd = new FormData();
    Object.entries({ order_id: order.id, product_id: item.product_id, rating, title, text }).forEach(([k, v]) => fd.append(k, v));
    if (photo) fd.append("photo", photo);
    try {
      await api.post("/reviews", fd);
      toast.success("Merci ! Votre avis sera publié après vérification.");
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={send} className="space-y-3 mt-3" data-testid={`review-form-${item.product_id}`}>
      <div className="flex gap-1">{[1, 2, 3, 4, 5].map((n) => (
        <button type="button" key={n} data-testid={`review-star-${n}`} onClick={() => setRating(n)} aria-label={`${n} étoiles`}>
          <Star className={`w-6 h-6 transition-colors ${n <= rating ? "fill-[#1C1A17] text-[#1C1A17]" : "text-black/20"}`} />
        </button>))}
      </div>
      <input data-testid="review-title" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={80} placeholder="Titre (facultatif)" className={inputCls} />
      <textarea data-testid="review-text" required minLength={10} maxLength={1000} rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder="Votre expérience avec ce produit (10 caractères min.)" className={inputCls} />
      <label className="block text-xs text-muted-foreground">Photo (facultatif, JPG/PNG/WEBP)
        <input data-testid="review-photo" type="file" accept="image/jpeg,image/png,image/webp" onChange={(e) => setPhoto(e.target.files?.[0] || null)} className="block mt-1 text-sm" />
      </label>
      <button data-testid="review-submit" disabled={busy} className={btnGold}>{busy ? "Envoi…" : "Publier mon avis"}</button>
    </form>
  );
}

export function OrderReviews({ order, mine, reload }) {
  const [open, setOpen] = useState(null);
  const delivered = order.status === "delivered" || (order.shipments || []).some((sh) => (sh.events || []).some((e) => e.code === "delivered"));
  if (!delivered) return null;
  const items = [...new Map(order.items.map((i) => [i.product_id, i])).values()];
  return (
    <div className="border border-black/10 p-6" data-testid="order-reviews">
      <div className="label-xs mb-3">Votre avis compte</div>
      {items.map((i) => {
        const done = mine.find((r) => r.order_id === order.id && r.product_id === i.product_id);
        return (
          <div key={i.product_id} className="py-3 border-b border-black/5 last:border-0">
            <div className="flex justify-between items-center gap-3 text-sm">
              <span>{i.title}</span>
              {done ? <span className="text-xs text-muted-foreground" data-testid={`review-done-${i.product_id}`}>{done.status === "approved" ? "Avis publié" : done.status === "rejected" ? "Avis non retenu" : "Avis en vérification"}</span>
                : <button data-testid={`review-open-${i.product_id}`} onClick={() => setOpen(open === i.product_id ? null : i.product_id)} className="text-sm underline">{open === i.product_id ? "Annuler" : "Laisser un avis"}</button>}
            </div>
            {open === i.product_id && !done && <ReviewForm order={order} item={i} onDone={() => { setOpen(null); reload(); }} />}
          </div>
        );
      })}
    </div>
  );
}
